const searchForSimpleUsersListSelect = (listRef, input, optionRef) => {
  const userSearch = (user) => user.name.toLowerCase().includes(input.toLowerCase()) && user.id === optionRef.value;
  const currentUser = listRef.value.filter(userSearch);
  return currentUser.length !== 0;
};

export { searchForSimpleUsersListSelect };
